import {Component, Input} from "@angular/core";
import {DialogComponent} from '../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../ng2-bootstrap-modal/dialog.service';

@Component({
    selector: 'db-video-dialog',
    templateUrl: './video-dialog.component.html',
    styleUrls: ['./video-dialog.component.scss'],
    standalone: false
})
export class VideoDialogComponent extends DialogComponent<null, Boolean> {

  @Input() url: string;
  constructor(
    private _dialogService: DialogService
  ) {
    super(
      _dialogService
    );
  }

}
